import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const ModalBody = ({ className, children }) => <div className={cx(styles.body, className)}>{children}</div>

ModalBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}

export default ModalBody
